import React from "react";
import { Table } from "@tanstack/react-table";
import {
  PaginationContainer,
  PaginationControls,
  PaginationButton,
  PageInfo,
  PageSizeSelector,
  PageSizeLabel,
  PageSizeSelect,
} from "./styles";

interface PaginationProps {
  table: Table<any>;
}

export const Pagination: React.FC<PaginationProps> = ({ table }) => {
  const {
    pagination: { pageIndex, pageSize },
  } = table.getState();
  const pageCount = table.getPageCount();
  const canPreviousPage = table.getCanPreviousPage();
  const canNextPage = table.getCanNextPage();

  return (
    <PaginationContainer>
      <PaginationControls>
        <PaginationButton
          onClick={() => table.previousPage()}
          disabled={!canPreviousPage}
        >
          Previous
        </PaginationButton>
        <PageInfo>
          Page {pageIndex + 1} of {pageCount || 1}
        </PageInfo>
        <PaginationButton
          onClick={() => table.nextPage()}
          disabled={!canNextPage}
        >
          Next
        </PaginationButton>
      </PaginationControls>

      <PageSizeSelector>
        <PageSizeLabel>Rows per page:</PageSizeLabel>
        <PageSizeSelect
          value={pageSize}
          onChange={(e) => table.setPageSize(Number(e.target.value))}
        >
          {[10, 25, 50, 100, 200, 500, 1000].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </PageSizeSelect>
      </PageSizeSelector>
    </PaginationContainer>
  );
};
